import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.PhotoHeader />
        <S.Wrapper>
          <S.Title>
            <span>Raio-X</span>
            <br /> de um desfile
          </S.Title>
          <S.Subtitle>
            Comme des Garçons
            <br />
            Inverno 2022.
          </S.Subtitle>
          <S.Credit>
            <p>
              Por Luigi Torre
              <br />
              <span>|</span>Fotos: Divulgação
            </p>
          </S.Credit>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};

export default Header;
